




































import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
import RegistrationMapping from "@/apps/registrations-api/pages/components/RegistrationMapping/index.vue";
import {BButton, BCard, BContainer, BNav, BNavItem, BOverlay, BSpinner} from "bootstrap-vue";

@Component({
  components: {
    RegistrationMapping,
    BContainer,
    BCard,
    BOverlay,
    BNav,
    BNavItem,
    BSpinner,
    BButton
  }
})
export default class CollectionNavigation extends Vue {
  @Prop({default: () => [], required: true})
  items: Array<RegistrationsAPI.Flows.Flow>

  @Prop({default: () => [], required: true})
  mappings: RegistrationsAPI.FlowMappings.FlowMapping[]

  hasBeenMapped(taskIds) {
    return this.mappings.some(x=>taskIds.includes(x.taskId))
  }


  async goTo(flow: RegistrationsAPI.Flows.Flow) {
    await this.$router.push({
      name: this.$route.name,
      params: {
        collection: this.$route.params.collection,
        flow: flow.uniqueId
      }
    })
  }
}
